export default __webpack_public_path__ + "static/media/github.37c69db2.png";